export const cloudinaryStillLifePhotos = [
  {
    publicId: "portfolio-nate-paradiso-photography/tyzjtcvqbv0gjbp9c1bn",
    height: 750,
    width: 500,
  },
  {
    publicId: "portfolio-nate-paradiso-photography/upv7j4lnkag8e7nuo83c",
    height: 750,
    width: 500,
  },
  // jordans

  {
    publicId: "portfolio-nate-paradiso-photography/mzhutagndhtrumy1cb5f",
    height: 1000,
    width: 1500,
  },
  {
    publicId: "portfolio-nate-paradiso-photography/k1euitnilrjc47pi6ibi",
    height: 1000,
    width: 1500,
  },
  {
    publicId: "portfolio-nate-paradiso-photography/yj7clvdf830havu4jdab",
    height: 1500,
    width: 1000,
  },
  {
    publicId: "portfolio-nate-paradiso-photography/zzfbbkrirhjxhxojr9h6",
    height: 1000,
    width: 1500,
  },
  {
    publicId: "portfolio-nate-paradiso-photography/skdamsjvt6bxpouhhm3f",
    height: 1500,
    width: 1000,
  },
  {
    publicId: "portfolio-nate-paradiso-photography/men9sbewukhu337fh8gt",
    height: 1500,
    width: 1000,
  },
  {
    publicId: "portfolio-nate-paradiso-photography/lvllwlxzdbaeuvcjukjd",
    height: 1000,
    width: 1500,
  },
  {
    publicId: "portfolio-nate-paradiso-photography/crpxsnka2i7psjo9hsph",
    height: 1000,
    width: 1500,
  },
  {
    publicId: "portfolio-nate-paradiso-photography/st00pmbh7hlwdmnjj5cf",
    height: 1000,
    width: 1500,
  },
  {
    publicId: "portfolio-nate-paradiso-photography/pop3vsc0kbbokjfkldvz",
    height: 1500,
    width: 1320,
  },
  {
    publicId: "portfolio-nate-paradiso-photography/urrtzssy9ccfme4xnhjj",
    height: 1000,
    width: 1500,
  },
  {
    publicId: "portfolio-nate-paradiso-photography/czljrf5rdqmzjkbnltj6",
    height: 1000,
    width: 1500,
  },
  {
    publicId: "portfolio-nate-paradiso-photography/ugclaxy0rk3m4kx3zgwt",
    height: 1000,
    width: 1500,
  },
  {
    publicId: "portfolio-nate-paradiso-photography/sfv8aendyd9ja7ksuilr",
    height: 1000,
    width: 1500,
  },
  {
    publicId: "portfolio-nate-paradiso-photography/lgwttjolwnkyeivckjsu",
    height: 1500,
    width: 1000,
  },
  {
    publicId: "portfolio-nate-paradiso-photography/x2cnqvhk0n0slw4wjob5",
    height: 1000,
    width: 1500,
  },
  {
    publicId: "portfolio-nate-paradiso-photography/vlztxxyorxnhx6fyeayw",
    height: 1000,
    width: 1500,
  },
  {
    publicId: "portfolio-nate-paradiso-photography/cw2ujmrwfuei31vdngzp",
    height: 1000,
    width: 1500,
  },
  {
    publicId: "portfolio-nate-paradiso-photography/umdokj0kjqiawd6luymp",
    height: 1500,
    width: 1500,
  },
  {
    publicId: "portfolio-nate-paradiso-photography/yo7ihgo1byodtcialy71",
    height: 1000,
    width: 1500,
  },

  // swaroski shoes
  {
    publicId: "portfolio-nate-paradiso-photography/aktnkekytndfvaqptduu",
    height: 1000,
    width: 1500,
  },
  {
    publicId: "portfolio-nate-paradiso-photography/pvvemyfx8xrtzqsl6pen",
    height: 1000,
    width: 1500,
  },
  {
    publicId: "portfolio-nate-paradiso-photography/ajsydg3b13ohvugjjszo",
    height: 1500,
    width: 594,
  },
  {
    publicId: "portfolio-nate-paradiso-photography/u2mqmpebqssem5kqfunx",
    height: 1000,
    width: 1500,
  },
  {
    publicId: "portfolio-nate-paradiso-photography/qqi9ah23wvrlmv7wqt8r",
    height: 1000,
    width: 1500,
  },
  {
    publicId: "portfolio-nate-paradiso-photography/p5uid3oygeksn1drue8g",
    height: 1000,
    width: 1500,
  },
];
